import React from 'react';
import { useSelector } from 'react-redux';

import { ShowComponentIfUserHasPermission } from 'RBAC/index';
import { BlossomRoutes, UserSettingsHomeRoute } from '../../../../../Routing/RouteConstants';
import TenantListMenu from '../TenantListMenu/TenantListMenu';
import Logout from '../../../../../Modules/Authentication/Logout/Logout';
import Logo from '../../../../../assets/images/logo-light.svg';
import MenuItem from './MenuItem';

const navLinkClasses =
  'ph3 w-100 no-underline white pointer fs-18 lh-21 flex items-center hover-bg-black-pearl bb b--black-pearl menu-item';
const profilePermissions = ['profiles', 'profile', 'r'];

function MenuItemsBottom({ closeMenu }) {
  const currentUser = useSelector((state) => state.users.currentUser);

  return (
    <div>
      <div className="bg-black-pearl ttc pa-small fs-18 lh-21">
        <div className={'fs-18 lh-21'}>
          <span>
            {currentUser.firstName || currentUser.lastName
              ? `${currentUser.firstName} ${currentUser.lastName}`
              : currentUser.userName}
          </span>
        </div>

        <ShowComponentIfUserHasPermission allowAny={true} permissionRef={profilePermissions}>
          <TenantListMenu />
        </ShowComponentIfUserHasPermission>
      </div>
      <div onClick={closeMenu}>
        <ShowComponentIfUserHasPermission allowAny={true} permissionRef={profilePermissions}>
          <MenuItem
            className={navLinkClasses}
            to={UserSettingsHomeRoute}
            data-testid="account-link"
            text="Account"
            segment={BlossomRoutes.userSettings.base}
          />
        </ShowComponentIfUserHasPermission>

        <Logout testId="logout-link" text="Logout" className={navLinkClasses + ' db'} />
      </div>
      <div className="pa-small-left flex items-center" style={{ height: 40 }}>
        <span className="fs-14 lh-16 fw3 mr2" style={{ height: 20 }}>
          Powered by
        </span>
        <span>
          <img alt="kobai logo" src={Logo} className="cover" style={{ height: 20, width: 60 }} />
        </span>
      </div>
      <div className="pa-small-left flex items-center" style={{ height: 20 }}>
        <span
          className="fs-12 lh-16 fw3 mr2"
          style={{ height: 20 }}
          title={import.meta.env.VITE_APP_REVISION}
        >
          {import.meta.env.VITE_APP_VERSION}
        </span>
      </div>
    </div>
  );
}

export default MenuItemsBottom;
